declare namespace $ {

	type $mol_view_tree2_to_js_test_ex_array_indexed_foo_tags__1 = $mol_type_enforce<
		ReturnType< $mol_view_tree2_to_js_test_ex_array_indexed_foo['slot'] >[number]
		,
		string
	>
	export class $mol_view_tree2_to_js_test_ex_array_indexed_foo extends $mol_object {
		tag1( id: any): string
		tag2( id: any): string
		slot( id: any): readonly(any)[]
		tags( id: any): readonly(string)[]
	}
	
}

//# sourceMappingURL=array_indexed.view.tree.d.ts.map